/** @returns the 360 photos of the selected project and the areas they are in */
export function capturedDataSelector({
  capturedData
}) {
  return capturedData;
}

/** @returns the status of the request that fetches the captured data */
export function capturedDataFetchingStatusSelector({
  capturedData
}) {
  return capturedData.fetchingStatus;
}